export const GridLayoutMode = {
	GRID: 'grid',
	CARD: 'card',
} as const;

export default GridLayoutMode;
